<template>
  <div>
    <breadcrumb-list>
      <breadcrumb-link view="Home" label="Home" />
      <breadcrumb-link view="InsuranceDiscoveryList" label="Blanket VOB Search" />
      <breadcrumb-link
        v-if="insuranceDiscovery"
        view="InsuranceDiscoveryDetails"
        :label="pageTitle"
        :params="{ id: insuranceDiscovery.id, payerResponseId: $route.params.payerResponseId }"
        :active="true"
      />
    </breadcrumb-list>

    <div v-if="insuranceDiscovery">
      <insurance-discovery-expired
        v-if="isInsuranceDiscoveryExpired"
        :insurance-discovery-id="insuranceDiscovery.id"
        :created-at="insuranceDiscovery.created_at"
      ></insurance-discovery-expired>

      <insurance-discovery-detail-plan
        v-else
        :insurance-discovery="insuranceDiscovery"
        :created-at="insuranceDiscovery.created_at"
        :as-of-date="insuranceDiscovery.created_at"
        :insurance-discovery-id="insuranceDiscovery.id"
        :provider="insuranceDiscovery.provider.name"
        :patient="{
          first_name: insuranceDiscovery.submission.patientFirstName,
          last_name: insuranceDiscovery.submission.patientLastName,
          dob: insuranceDiscovery.submission.patientDOB,
        }"
        :payers="selectedPayer"
      ></insurance-discovery-detail-plan>
    </div>
  </div>
</template>

<script>
import InsuranceDiscoveryDetailPlan from '../components/InsuranceDiscoveryDetailPlan.vue';
import InsuranceDiscoveryExpired from '../components/InsuranceDiscoveryExpired.vue';
import request from '../request';

export default {
  name: 'InsuranceDiscoveryDetails',
  components: {
    InsuranceDiscoveryDetailPlan,
    InsuranceDiscoveryExpired,
  },
  computed: {
    pageTitle() {
      if (this.insuranceDiscovery?.submission) {
        let firstName = this.insuranceDiscovery.submission.patientFirstName;
        let lastName = this.insuranceDiscovery.submission.patientLastName;
        return `${firstName} ${lastName}`;
      }
      return this.insuranceDiscovery.id;
    },
    isInsuranceDiscoveryExpired() {
      if (!this.insuranceDiscovery) return false;
      const twoMonthsAgo = new Date(Date.now() - 60 * 24 * 60 * 60 * 1000);
      return this.insuranceDiscovery.created_at < twoMonthsAgo;
    },
    selectedPayer() {
      if (!this.insuranceDiscovery || !this.$route.params.payerResponseId) {
        return [];
      }
      const payer = this.insuranceDiscovery.insurance_discovery_payers.find(
        (payer) => payer.id === this.$route.params.payerResponseId
      );
      return payer ? [payer] : [];
    },
  },
  data() {
    return {
      insuranceDiscovery: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    request
      .get(`/blanket-vob-search/${to.params.id}`)
      .then((resp) => {
        let status = resp.data.insurance_discovery.status;
        if (status === 'complete' || status === 'error') {
          next((vm) => (vm.insuranceDiscovery = resp.data.insurance_discovery));
        } else {
          next({ name: 'NotFound' });
        }
      })
      .catch(() => {
        next({ name: 'NotFound' });
      });
  },
};
</script>
